import template from './loansSignUpConfirmationModal.html';
import controller from './loansSignUpConfirmationModal.controller';
import './loansSignUpConfirmationModal.scss';

let loansSignUpConfirmationModalComponent = {
  restrict: 'E',
  bindings: {
    loanId: '<',
    confirmLoan: '&',
    isMobileApp: '<',
  },
  template,
  controller,
};

export default loansSignUpConfirmationModalComponent;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/loansSignUp/loansSignUpConfirmationModal/loansSignUpConfirmationModal.component.js